import { render, staticRenderFns } from "./ResourcesListHorizontalCsr.vue?vue&type=template&id=48e91a67"
import script from "./ResourcesListHorizontalCsr.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourcesListHorizontalCsr.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports